import { render, staticRenderFns } from "./SupportingDocuments.vue?vue&type=template&id=ec0041a0&scoped=true"
import script from "./SupportingDocuments.vue?vue&type=script&lang=ts"
export * from "./SupportingDocuments.vue?vue&type=script&lang=ts"
import style0 from "./SupportingDocuments.vue?vue&type=style&index=0&id=ec0041a0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec0041a0",
  null
  
)

export default component.exports